export interface IToastData {
    message: string;
    title?: string;
    level: 'ERROR' | 'WARNING' | 'INFO' | 'SUCCESS';
    params?: any;
}

export class ToastData implements IToastData {
    constructor(parameters: IToastData, id: number) {
        this.message = parameters.message;
        this.level = parameters.level;
        this.title = parameters.title || `general.${parameters.level}`;
        this.params = parameters.params;
        this.id = id;
    }
    public id: number;
    public message: string;
    public level: 'ERROR' | 'WARNING' | 'INFO' | 'SUCCESS';
    public title: string;
    public params?: any;
}
